import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ICellRendererAngularComp } from 'ag-grid-angular';

import { DriverIndexComponent } from '../../dialogs/driver-index/driver-index.component';
import { ReportsService, TransformedSingleData } from '../../services/reports.service';
import { CommonService } from '../../services/common.service';
import { DriverIndexClassicComponent } from 'src/app/dialogs/driver-index-classic/driver-index-classic.component';

import { DrilldownFormsService } from '../../services/drilldown-forms.service';

@Component({
  selector: 'grid-see-pcc-link-button',
  template: `
    <span>
      <button
        mat-button
        fxFlex
        class="grid-link-button grid-text"
        *ngIf="value && value.toLowerCase() === 'required'; else displayValueOnly"
        [style.color]="transformedValue?.color"
        (click)="triggerLinkButtonAction()"
      >
        {{ translatedValue }}
      </button>

      <ng-template #displayValueOnly>{{ translatedValue }}</ng-template>
    </span>
  `,
  styles: [],
})
export class GridSeePccLinkButtonComponent implements ICellRendererAngularComp {
  public value: string;
  public translatedValue: string;
  public transformedValue: TransformedSingleData;

  private classicDriverIndexDialog = DriverIndexClassicComponent;
  private driverIndexDialog = DriverIndexComponent;
  private parameters: { value?: any; data?: any };

  constructor(
    private dialog: MatDialog,
    private rptService: ReportsService,
    private cService: CommonService,
    private dfService: DrilldownFormsService
  ) {}

  agInit(params: { value: any }) {
    this.value = params.value;
    this.parameters = params;

    this.transformedValue = this.rptService.transformSingleDataForDetailsPane('pccCourseStatus', params.value);

    if (this.transformedValue) {
      this.translatedValue = this.transformedValue.uiValue;
    }
  }

  triggerLinkButtonAction() {
    setTimeout(() => {
      const defaultSelection = this.parameters.data;
      const selectedRow = this.rptService.selectedRows[0];
      const pccIncompleteCourses = selectedRow.pccUncompleteCourses;

      if (this.rptService.selectedRows.length === 0) {
        if (this.parameters.data) {
          this.rptService.selectedRows.push(this.parameters.data);
        }
      }

      if (this.cService.userProfile.manages && this.cService.userProfile.manages.length > 0) {
        this.rptService.autoPopulateManagedDriversForManagement();
      }

      if (defaultSelection) {
        const renderClassicOrModernDialog: any =
          this.cService.userProfile.companySettings &&
          this.cService.userProfile.companySettings.driverPerformanceClassic === 'TRUE'
            ? this.classicDriverIndexDialog
            : this.driverIndexDialog;

        this.dfService.currentTabIndex = this.dfService.drilldownTabs.history.id;

        this.dialog
          .open(renderClassicOrModernDialog, {
            maxHeight: this.cService.isMobileViewport ? '100%' : '',
            maxWidth: this.cService.isMobileViewport ? '100%' : '',
            height: '100%',
            width: this.cService.isMobileViewport ? '100%' : '95%',

            data: {
              selectedRow: defaultSelection,
              reportEndpointName: this.rptService.currentReportOptions.reportEndpointName,
              autoExpandPccForm: pccIncompleteCourses == 1 ? true : false,
              defaultTab:
                pccIncompleteCourses > 1
                  ? this.dfService.drilldownTabs.history.id
                  : this.dfService.drilldownTabs.insights.id,
              rowToOpen: 10,
            },

            disableClose: true,
          })

          .afterClosed()
          .subscribe(() => {
            this.rptService.triggerDriverPerformanceDialogClosedObservable(this.rptService.endpointFilterValue, true);
          });
      }
    }, 100);
  }

  refresh() {
    return false;
  }
}
